import { CustomStatusRenderer } from '../../renderer';
import {
  dateValueFormatterWithHHMM,
  dateTimeComparatorAgGrid,
  valueFormatterAgGrid,
} from '../../utils';
import {StatusDecorator,targetAppDecorator,targetWorkflowDecorator} from './StatusDecorator';
import { CustomOutageDeleteRenderer } from './CustomDeleteRenderer';
import { Button, BUTTON_VARIANTS, IconContentCopy } from 'cdk-radial';

export const defaultColDef = {
  enablePivot: true,
  sortable: true,
  filter: true,
  flex: 1,
  autoHeight: true,
  minWidth: 100,
  resizable: true,
  refreshCells: true,
  headerHeight: '150px',
};

export const excelConfig = {
  excelStyles: [
    {
      id: 'header',
      font: {
        bold: true,
        size: 15,
      },
      interior: {
        color: '#bbb4bb',
        pattern: 'Solid',
      },
    },
  ],
  fileName: 'Product_Outages_' + new Date().toJSON().slice(0, 10),
  allColumns: true,
  processCellCallback: function ({ column, value }: any) {
    return StatusDecorator(column.colId,value);
  },
};


export const getColumnDefs = (permissions: any,applications:any,workflows:any ,archiveSwitch:any, t: Function) => {
  let columnDefinition = [
    {
      field: 'title',
      headerName: t('productAlerts.colTitle'),
      cellClass: 'formattedColumn',
    },
    {
      field: 'caseId',
      headerName: t('productAlerts.colCaseNumber'),
      cellClass: 'formattedColumn',
    },
    {
      field: 'target.application',
      headerName: t('productAlerts.colTargetApps'),
      cellClass: 'formattedColumn',
      cellRenderer: (params: any) =>
      targetAppDecorator(params.data?.target?.application,applications),
    },
    {
      field: 'target.workflow',
      headerName: t('productAlerts.colTargetWorkflows'),
      cellClass: 'formattedColumn',
      cellRenderer: (params: any) =>
      targetWorkflowDecorator(params.data?.target?.workflow,workflows),
    },
    {
      field: 'target.enterpriseIds',
      headerName: t('productAlerts.colTargetEnterprises'),
      cellClass: 'formattedColumn',
    },
    {
      cellRenderer: (params: any) =>
        dateValueFormatterWithHHMM(params.data.createdDate),
      cellClass: 'formattedColumn',
      field: 'createdDate',
      headerName: t('productAlerts.colCreatedDateTime'),
      sortable: true,
      filterParams: {
        comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
        valueFormatter: (params: any) => valueFormatterAgGrid(params),
      },
    },
    {
      field: 'createdBy',
      headerName: t('productAlerts.colCreatedBy'),
      cellClass: 'formattedColumn',
    },
    {
      cellRenderer: (params: any) =>
        dateValueFormatterWithHHMM(params.data.lastUpdatedDate),
      cellClass: 'formattedColumn',
      field: 'lastUpdatedDate',
      headerName: t('productAlerts.colUpdatedDateTime'),
      sortable: true,
      filterParams: {
        comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
        valueFormatter: (params: any) => valueFormatterAgGrid(params),
      },
    },
    {
      field: 'lastUpdatedBy',
      headerName: t('productAlerts.colUpdatedBy'),
      cellClass: 'formattedColumn',
    },
    {
      cellRenderer: (params: any) =>
        dateValueFormatterWithHHMM(params.data.startDate),
      field: 'startDate',
      headerName: t('productAlerts.colStartDateTime'),
      sortable: true,
      cellClass: 'formattedColumn',
      filterParams: {
        comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
        valueFormatter: (params: any) => valueFormatterAgGrid(params),
      },
    },
    {
      cellRenderer: (params: any) =>
        dateValueFormatterWithHHMM(params.data.endDate),
      field: 'endDate',
      headerName: t('productAlerts.colEndDateTime'),
      sortable: true,
      cellClass: 'formattedColumn',
      filterParams: {
        comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
        valueFormatter: (params: any) => valueFormatterAgGrid(params),
      },
    },
    {
      field: 'active',
      cellRenderer: (params: any) => (
        <CustomStatusRenderer isActive={params.data.active} startDate={params.data.startDate} endDate={params.data.endDate}/>
      ),
      headerName: t('productAlerts.colStatus'),
      sortable: true,
      colId : 'Status'
    },
    {
      colId: 'Delete',
      cellRenderer: (params: any) => <CustomOutageDeleteRenderer />,
      sortable: true,
      getQuickFilterText: (params: any) => {
        return '';
      },
    },
    {
      colId: 'Duplicate',
      cellRenderer: (params: any) => <Button
      title="Copy"
      icon={<IconContentCopy />}
      text="Duplicate"
      variant={BUTTON_VARIANTS.ICON}
      onClick={""}
    />,
      sortable: true
    },
  ];

  if (!permissions?.hasProductAlertUpdatePermissions || archiveSwitch === true) {
    columnDefinition = columnDefinition.filter((col) => col.colId !== 'Delete');
  }

  if (archiveSwitch === true) {
    columnDefinition = columnDefinition.filter((col) => col.colId !== 'Status' && col.colId !== 'Duplicate');
  }

  return columnDefinition;
};
